(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyPaymentLogListV2Controller', CompanyPaymentLogListV2Controller);

    CompanyPaymentLogListV2Controller.$inject = ['$scope', '$state', 'CompanyPaymentLog', 'ParseLinks', 'AlertService', '$mdDialog', 'CompanyPaymentLogCustom', 'AccountClearingRequestCustom', 'QueryParamsService', 'InvoiceInfoCustom', 'Principal', '$uibModal'];

    function CompanyPaymentLogListV2Controller($scope, $state, CompanyPaymentLog, ParseLinks, AlertService, $mdDialog, CompanyPaymentLogCustom, AccountClearingRequestCustom, QueryParamsService, InvoiceInfoCustom, Principal, $uibModal) {
        var vm = this;
        vm.sumPaymentAmount = 0;
        vm.sumWage = 0;
        vm.sumRemaindAmount = 0;
        vm.accountClearRequest = accountClearRequest;
        vm.activeClearRequest = {};
        vm.canSendRequest = false;
        vm.pageSizeChanged = pageSizeChanged;
        vm.transition = transition;
        vm.pageSizeList = [10, 20, 50];
        vm.size = 10;
        vm.page = 1;
        vm.newAccountClearingRequestLoading = false;

        loadAll();

        function loadAll() {


            vm.companyPaymentLogs = CompanyPaymentLogCustom.getActiveCompanyPaymentLogs().query(function (result) {
                calculateSum();
            });


            AccountClearingRequestCustom.getActiveCompanyAccountClearingRequest().query().$promise.then(function (result) {


                    vm.activeClearRequest = result;
                }
            );

        }


        function calculateSum() {
            sumPaymentAmount();
            sumWage();
            vm.sumPaymentAmount = Math.round(vm.sumPaymentAmount);
//            vm.sumWage = Math.round(vm.sumWage);
            vm.sumRemaindAmount = vm.sumPaymentAmount ;
            if (vm.sumRemaindAmount >= 200000)
                vm.canSendRequest = true;
            else
                vm.canSendRequest = false;
        }

        function sumPaymentAmount() {
            angular.forEach(vm.companyPaymentLogs, function (p) {

                vm.sumPaymentAmount += p.paymentAmount;
            });

        }

        function sumWage() {
            angular.forEach(vm.companyPaymentLogs, function (p) {

                vm.sumWage += p.wageFeeAmount;
            });

        }

        function accountClearRequest() {
            vm.newAccountClearingRequestLoading = true;
            AccountClearingRequestCustom.createNewAccountClearingRequest().save(function (result) {
                    $scope.$emit('tikonApp:accountClearingRequestUpdate', result);
                    loadAll();
                    vm.newAccountClearingRequestLoading = false;
                },
                function(error) {
                    console.log(error);
                    vm.newAccountClearingRequestLoading = false;
                }
            );

        }




        function pageSizeChanged() {
            QueryParamsService.updateFilter('size', vm.size)
            clear();
        }


         function transition() {
            // $state.transitionTo($state.$current, {
            //     page: vm.page,
            //     sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
            //     search: vm.currentSearch
            // });
            if (vm.filterQuery.searchMode)
                getPaymentLogsPagesByQuery(vm.filterQuery);
            else
                getPaymentLogsPagesByQuery();

        }

        //function transition () {
        //    $state.transitionTo($state.$current, {
        //        page: vm.page,
        //        sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
        //        search: vm.currentSearch
        //    });
        //}
    }
})();
